var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9d12285e-995f-4c26-bfd3-abf6ed91d276a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000713",
    fillRule: "evenodd",
    d: "M2.149 7.426a6 6 0 0 0 0 2.666h2.626a11 11 0 0 1-.108-1.347q.013-.665.108-1.32zm.475-1.334h2.429a10.9 10.9 0 0 1 1.43-3.14 6 6 0 0 0-3.86 3.14zM8 3.126a9.5 9.5 0 0 0-1.557 2.966h3.114A9.5 9.5 0 0 0 8 3.126m1.876 4.3H6.124A9.5 9.5 0 0 0 6 8.759q.016.675.124 1.333h3.752A9.5 9.5 0 0 0 10 8.76a9.5 9.5 0 0 0-.124-1.333zm1.349 2.666a11 11 0 0 0 .108-1.347 11 11 0 0 0-.108-1.32h2.626a6 6 0 0 1 0 2.667zm-1.668 1.334H6.443A9.5 9.5 0 0 0 8 14.392a9.5 9.5 0 0 0 1.557-2.966m-3.073 3.14a10.9 10.9 0 0 1-1.431-3.14h-2.43a6 6 0 0 0 3.86 3.14zm3.032 0a10.9 10.9 0 0 0 1.431-3.14h2.43a6 6 0 0 1-3.86 3.14zm3.86-8.474h-2.429a10.9 10.9 0 0 0-1.43-3.14 6 6 0 0 1 3.86 3.14zM.666 8.76a7.333 7.333 0 1 1 14.667 0 7.333 7.333 0 0 1-14.666 0z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9d12285e-995f-4c26-bfd3-abf6ed91d276a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .76h16v16H0z"
  })))));
};
export default SvgGlobe;